export const APP_CONFIG = {
  dateFormat: 'yyyy-MM-dd',
  axis: {
    x: {
      color: '#911',
    },
    y: {
      color: '#911',
    },
  },
  backgroundColors: [
    '#58A4B0',
    '#050505',
    '#FE6121',
    '#D0E37F',
    '#22577A',
    '#716969',
    '#E44343',
    '#373F51',
    '#ECEBE4',
    '#9CAFB7',
  ],
};
